const Home = () => {
  return (
    <div> Welcome to Tenways</div>
  )
}

export default Home;